import WeeklyHoursSection from './WeeklyHoursSection';

export default WeeklyHoursSection;
